<template lang="html">
  <div>
    <v-flex
      v-if="section.textPre"
      xs12
      mb-4
      v-html="section.textPre"
    />

    <div
      v-for="(output, oi) in outputs"
      :key="oi"
    > 
      <v-flex
        v-if="output.label"
        mb-2
        class="body-2"
      >
        {{ output.label }}
      </v-flex>
      <v-flex
        v-if="output.pensionSlider"
        xs12
      >
        <v-alert 
          dense 
          type="warning" 
          class="only-print body-2"  
          outlined
          border="left" 
        >
          Values in this section of report are dynamic and were set by the user at the time of printing.
        </v-alert>
        <v-slider
          v-model="pensionSlider"
          :label="`Part pension percentage (${pensionSlider}%)`"
          :max="100"
          :min="50"
          hide-details
          thumb-labelxxx
        />
      </v-flex>
      <v-layout
        v-for="(value, vi) in output.values"
        :key="`${oi}_${vi}`"
        ma-0
      >
        <v-flex xs12>
          {{ value.label }}
        </v-flex>
        <v-flex
          shrink
          class=""
        >
          {{ value.value }}
        </v-flex>
      </v-layout>
      <v-layout
        v-if="scheme === 'pss' && oi < outputs.length - 1"
        align-center
        ma-0
      >
        <v-divider />
        <v-flex
          shrink
          px-3
          class="subtitle-2"
        >
          OR
        </v-flex>
        <v-divider />
      </v-layout>
    </div>

    <v-flex
      v-if="section.textPost"
      xs12
      mt-4
      v-html="section.textPost"
    />
  </div>
</template>

<script>
import helpers from '@/mixins/helpers'

export default {
  mixins: [ helpers ],
  props: {
    data: Object,
    section: Object
  },
  data: () => ({
      pensionSlider: .3
  }),
  computed: {
    report () {
      return this.data.report || {}
    },
    reportData () {
      return this.report.data || {}
    },
    scheme () {
      return (this.reportData.super_scheme || {}).value
    },
    pensionPercentage () {
      return this.pensionSlider / 100
    },
    outputs () {
      let { pension, components, funded_component } = this.data.result || {}

      const createPssValues = ({percentage}) => {
        let pensionValue = pension * percentage 
        let residual = components * (1 - percentage)
        
        return [
          { label: 'Pension (per year)', value: this._$(pensionValue) },
          { label: 'Lump sum', value: this._$(residual) }
        ]
      }
      
      const createCssValues = () => [
        { label: 'Standard indexed pension from unfunded component (per year)', value: this._$(pension) },
        { label: 'Lump sum', value: this._$(funded_component) }
      ]
      

      switch (this.scheme) {
        case 'pss': return [
          { label: 'Option 1. Lump sum only (1)', values: createPssValues({percentage: 0}) },
          { label: 'Option 2. Part pension, part lump sum (1)(2)(3)', values: createPssValues({percentage: this.pensionPercentage}), pensionSlider: true },
          { label: 'Option 3. Maximum pension (2)', values: createPssValues({percentage: 1}) },
        ]
        case 'css': return [
          { label: null, values: createCssValues() }
        ]
      }
      return null
      
    },
  },
  methods: {

  }
}
</script>

<style lang="css" scoped>

</style>
